import { render, staticRenderFns } from "./Bravo.vue?vue&type=template&id=2f1b76be&"
import script from "./Bravo.vue?vue&type=script&lang=js&"
export * from "./Bravo.vue?vue&type=script&lang=js&"
import style0 from "./Bravo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports